export default __webpack_public_path__ + "static/media/boy1.4b3a7272.jpg";